import React from "react";
import PropTypes from "prop-types";
import "./InputPlaceHolder.scss";

const InputPlaceHolder = ({
  updateChanges,
  index,
  value,
  unit,
  name,
  selected,
  isNumber,
  onfocusin,
  onfocusout,
  error,
  tooltip,
  ...props
}) => (
  <div className={`InputPlaceHolder unit_input${selected ? " select-highlight" : ""}`} {...props}>
    <input
      className={`${unit ? "lpr-input" : "lpr-input-full"} ${error ? "bg-red-100" : ""}`}
      type={isNumber ? "number" : "text"}
      value={value}
      name={name}
      onFocus={(event) => {
        event.target.select();
        if (onfocusin !== null && onfocusin !== undefined) onfocusin(index, event);
      }}
      onBlur={onfocusout}
      onChange={(event) => updateChanges(index, event)}
      title={tooltip}
    />
    {unit && <span className="placeholderunit">{unit}</span>}
  </div>
);

InputPlaceHolder.propTypes = {
  updateChanges: PropTypes.func,
  index: PropTypes.number,
  value: PropTypes.any,
  unit: PropTypes.string,
  name: PropTypes.string,
  // inputClasses: PropTypes.string,
  selected: PropTypes.bool,
  isNumber: PropTypes.bool,
  onfocusin: PropTypes.func,
  onfocusout: PropTypes.func,
  error: PropTypes.bool,
  tooltip: PropTypes.string
};

InputPlaceHolder.defaultProps = {
  updateChanges: null,
  index: null,
  value: null,
  unit: null,
  name: null,
  // inputClasses: null,
  selected: false,
  isNumber: false,
  onfocusin: null,
  onfocusout: null,
  error: false,
  tooltip: null
};
export default InputPlaceHolder;
